var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReleaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 41,
    viewBox: "0 0 47 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1584 7.2167C43.1584 6.93759 43.1034 6.66121 42.9966 6.40335C42.8898 6.14548 42.7332 5.91118 42.5359 5.71382C42.3385 5.51646 42.1042 5.3599 41.8463 5.25309C41.5885 5.14628 41.3121 5.09131 41.033 5.09131H5.96523C5.68612 5.09131 5.40975 5.14628 5.15188 5.25309C4.89402 5.3599 4.65972 5.51646 4.46236 5.71382C4.265 5.91118 4.10844 6.14548 4.00163 6.40335C3.89482 6.66121 3.83984 6.93759 3.83984 7.2167V33.7829C3.83984 34.3466 4.06377 34.8872 4.46236 35.2858C4.86094 35.6844 5.40154 35.9083 5.96523 35.9083H41.033C41.5967 35.9083 42.1373 35.6844 42.5359 35.2858C42.9345 34.8872 43.1584 34.3466 43.1584 33.7829V7.2167Z",
    stroke: "#0E2C66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7228 5.09141L39.0513 2.58064C38.9053 2.03626 38.549 1.57217 38.0609 1.29044C37.5727 1.0087 36.9926 0.93241 36.4482 1.07833L21.4713 5.09141M43.159 31.1845L44.4236 30.8453C44.6933 30.7731 44.9461 30.6485 45.1676 30.4787C45.3891 30.3088 45.5749 30.0969 45.7145 29.8552C45.8542 29.6135 45.9448 29.3466 45.9813 29.0698C46.0177 28.7931 45.9993 28.5119 45.9271 28.2422L43.1578 17.9118M7.27663 35.9084L7.94817 38.418C8.02034 38.6877 8.14493 38.9405 8.31482 39.162C8.4847 39.3835 8.69656 39.5693 8.93829 39.7089C9.18001 39.8485 9.44687 39.9392 9.72363 39.9756C10.0004 40.0121 10.2816 39.9937 10.5513 39.9215L25.5282 35.9084M3.84047 9.81527L2.57585 10.1545C2.3062 10.2267 2.0534 10.3513 1.8319 10.5211C1.6104 10.691 1.42454 10.9029 1.28492 11.1446C1.14531 11.3863 1.05468 11.6532 1.01821 11.93C0.981747 12.2067 1.00016 12.4879 1.07239 12.7576L3.85778 23.1514M10.7474 11.4676H36.2509M10.7474 17.4895H36.2509M10.7474 23.5103H36.2509M10.7474 29.5322H23.4997",
    stroke: "#0E2C66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseIcon);
export default __webpack_public_path__ + "static/media/releaseIcon.eadea8238c4e0c947e1ca1254bab908b.svg";
export { ForwardRef as ReactComponent };